export default __webpack_public_path__ + "static/media/3233 spice rack C side.38b805ec.png";